import { HEADER_THEMES } from '../types';

export const getBackgroundColor = (theme: HEADER_THEMES) => {
  switch (theme) {
    case 'dark':
    case 'r-note-teaser':
      return 'transparent';
    case 'new-homepage':
      return '#071022'; // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
    case 'light':
    default:
      return 'white';
  }
};
